import { render, staticRenderFns } from "./activitylistDetailReport.vue?vue&type=template&id=66b7ff53"
import script from "./activitylistDetailReport.vue?vue&type=script&lang=js"
export * from "./activitylistDetailReport.vue?vue&type=script&lang=js"
import style0 from "./activitylistDetailReport.vue?vue&type=style&index=0&id=66b7ff53&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports